<template>
  <div class="base">
    <inside-header title="我的服务包" />
    <div class="main">
      <van-form input-align="right" @submit="onSubmit">
        <van-field v-model="title" label="名称" name="title" placeholder="服务包名称"
          :rules="[{ required: true, message: '请填写服务包名称' }]" />
        <van-field name="cycle" label="可选周期">
          <template #input>
            <van-slider v-model="cycle" range :min="min_service_cycle_range" :max="max_service_cycle_range"
              :rules="[{ required: true, message: '请选择可选周期' }]" @change="onCycleChange" />
          </template>
        </van-field>
        <!-- 提高科目 -->
        <!-- <van-field
          readonly
          clickable
          label="可授课"
          :value="info.week_day"
          @click="state.weekDay = true"
        />
        <van-popup v-model="state.weekDay" position="bottom">
          <van-tree-select
            show-toolbar
            :items="items"
            :active-id.sync="activeIds"
            :main-active-index.sync="activeIndex"
          />
        </van-popup> -->
        <van-field name="checkboxGroup" label="授课日期">
          <template #input>
            <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
              <van-checkbox name="monday" shape="square">
                周一
              </van-checkbox>
              <van-checkbox name="tuesday" shape="square">
                周二
              </van-checkbox>
              <van-checkbox name="wednesday" shape="square">
                周三
              </van-checkbox>
              <van-checkbox name="thursday" shape="square">
                周四
              </van-checkbox>
              <van-checkbox name="friday" shape="square">
                周五
              </van-checkbox>
              <van-checkbox name="saturday" shape="square">
                周六
              </van-checkbox>
              <van-checkbox name="sunday" shape="square">
                周日
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field name="subject" label="选择课程">
          <template #input>
            <van-checkbox-group v-model="subject" direction="horizontal">
              <van-checkbox v-for="(course, index) in allow_course" :key="index" :name="course" shape="square">
                {{ course }}
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field name="dayRange" label="授课时间范围">
          <template #input>
            <van-slider v-model="dayRange" range :min="min_service_day_range" :max="max_service_day_range"
              :rules="[{ required: true, message: '请选择授课范围' }]" @change="onDayRangeChange" />
          </template>
        </van-field>
        <van-field v-model="endTime" readonly clickable name="end_time" label="截至日期" placeholder="点击选择日期"
          :rules="[{ required: true, message: '请点击选择日期' }]" @click="state.showCalendar = true" />
        <van-calendar v-model="state.showCalendar" :show-confirm="false" @confirm="endTimeonConfirm" />
        <!-- 允许输入数字，调起带符号的纯数字键盘 -->
        <van-field v-model="price" name="price" :min="min_service_price_range" :max="max_service_price_range"
          type="number" label="金额(每小时)"
          :rules="[{ required: true, message: '请输入金额' }, { validator, message: '请输入在' + min_service_price_range + '到' + max_service_price_range + '的价格' }]" />
        <van-field v-model="desc" rows="2" autosize name="desc" label="描述信息" type="textarea" maxlength="100"
          placeholder="该家教服务描述(255个字)" show-word-limit :rules="[{ required: true, message: '请输入描述信息' }]" />
        <!-- 是否展示 -->
        <van-field name="status" label="是否上架">
          <template #input>
            <van-switch v-model="status" size="20" />
          </template>
        </van-field>
        <van-field name="agreement" label="服务协议" :rules="[{ required: true, message: '请阅读并勾选服务协议' }]">
          <!-- 使用 input 插槽来自定义输入框 -->
          <template #input>
            <van-checkbox v-model="agreement">
              <span>我已阅读并同意</span>
              <a href="" style="color: #ff5c00;margin-left: 5px;">服务协议</a>
            </van-checkbox>
          </template>
        </van-field>
        <div style="margin: 16px;text-align:center" class="btn-area">
          <a-button class="save-btn" html-type="submit" type="primary" block
            style="width:315px;background-color:#ff5c00;border-radius:10px">
            {{ pageType === 'edit' ? '保存' : '添加' }}
          </a-button>
          <a-button v-if="pageType == 'edit'" class="del-btn" block @click="goDelete(id)">
            删除
          </a-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

// const items = [
//   {
//     // 导航名称
//     text: '授课日期',
//     // 导航名称右上角徽标，2.5.6 版本开始支持
//     badge: 3,
//     // 是否在导航名称右上角显示小红点
//     dot: true,
//     // 导航节点额外类名
//     className: 'my-class',
//     // 该导航下所有的可选项
//     children: [
//       {
//         // 名称
//         text: '周一',
//         // id，作为匹配选中状态的标识符
//         id: 1,
//         // 禁用选项
//         disabled: true
//       },
//       {
//         text: '周二',
//         id: 2
//       },
//       {
//         text: '周三',
//         id: 3
//       },
//       {
//         text: '周四',
//         id: 4
//       },
//       {
//         text: '周五',
//         id: 5
//       },
//       {
//         text: '周六',
//         id: 6
//       },
//       {
//         text: '周日',
//         id: 7
//       }
//     ]
//   }
// ]

export default {
  name: 'TutorPay',
  components: {
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      state: {
        weekDay: false,
        showCalendar: false
      },
      info: {},
      checkboxGroup: [],
      cycle: [2, 10],
      activeIds: [1, 2],
      activeIndex: 0,
      dayRange: [8, 20],
      min_service_cycle_range: 2,
      max_service_cycle_range: 10,
      min_service_day_range: 8,
      max_service_day_range: 21,
      endTime: '',
      // 后端设置的每小时收费价格范围
      service_price_range: [],
      min_service_price_range: 35,
      max_service_price_range: 300,
      price: 35,
      desc: '',
      status: false,
      agreement: false,
      pageType: 'add',
      allow_course: [],
      subject: [],
      title: '',
      min_cycle: 2,
      max_cycle: 8,
      min_day: 8,
      max_day: 21
    }
  },
  created() {
    console.log(this.id)
    // 1.判断id是否存在，当前是保存还是新增
    // 2.如果是编辑，请求该服务包数据并赋值
    // this.loadData(this.id, this.$route.query)
    this.loadBaseData()
    if (this.id !== undefined && this.id !== '') {
      this.pageType = 'edit'
      //  1.请求服务包数据
      this.loadPackInfo(this.id)
    } else {
      this.pageType = 'add'
    }
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
    loadBaseData() {
      this.$http({
        url: 'index/teacher/servicePackAdditional',
        method: 'get'
      }).then(res => {
        console.log(0, res.data)
        var data = res.data
        this.min_service_cycle_range = data.service_cycle_range[0]
        this.max_service_cycle_range = data.service_cycle_range[1]
        this.min_service_day_range = data.service_day_range[0]
        this.max_service_day_range = data.service_day_range[1]
        this.min_service_price_range = data.service_price_range[0]
        this.max_service_price_range = data.service_price_range[1]
        this.allow_course = data.allow_course
      })
    },
    loadPackInfo(id) {
      this.$http({
        url: 'index/teacher/servicePackInfo',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        var data = res.data
        // 赋值
        var servicePack = data.service_pack
        this.title = servicePack.title
        this.price = servicePack.price
        this.desc = servicePack.desc
        this.subject = servicePack.teaching_subjects.split(',')
        this.checkboxGroup = servicePack.week_day.split(',')
        this.endTime = this.$options.filters.dayFormat(servicePack.end_time)
        this.status = servicePack.status === 1

        this.min_cycle = servicePack.min_cycle
        this.max_cycle = servicePack.max_cycle
        // 周期赋值
        this.$set(this.cycle, 0, servicePack.min_cycle)
        this.$set(this.cycle, 1, servicePack.max_cycle)
        // 授课时间赋值
        this.$set(this.dayRange, 0, servicePack.min_day)
        this.$set(this.dayRange, 1, servicePack.max_day)
        this.min_day = servicePack.min_day
        this.max_day = servicePack.max_day
      })
    },
    onSubmit(e) {
      console.log(2, e)
      // 得到的数据结构不对，所以用paramData封装
      var paramData = {}
      paramData.price = e.price
      paramData.min_cycle = e.cycle[0]
      paramData.max_cycle = e.cycle[1]
      paramData.min_day = e.dayRange[0]
      paramData.max_day = e.dayRange[1]
      paramData.desc = e.desc
      paramData.status = e.status
      paramData.title = e.title
      paramData.teaching_subjects = this.subject // e是表单中的参数
      paramData.week_day = this.checkboxGroup.toString()
      var date = new Date(e.end_time.replace(/-/g, '/'))// 将年-月-日转换为年/月/日，并初始化为年/月/日
      paramData.end_time = parseInt(Date.parse(date) / 1000)
      console.log(paramData)
      var url = ''
      if (this.pageType === 'add') {
        url = 'index/teacher/servicePackCreate'
      } else {
        url = 'index/teacher/servicePackSave'
        paramData.id = this.id
      }
      this.$http({
        url: url,
        method: 'post',
        data: paramData
      }).then(res => {
        console.log(res)
        const _this = this
        if (res.status === 'success') {
          setTimeout(function () {
            _this.$router.push({ name: 'TeacherServerPack' })
          }, 1000)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    onCycleChange(value) {
      this.$toast(value[0] + '，' + value[1])
    },
    onDayRangeChange(value) {
      this.$toast(value[0] + '，' + value[1])
    },
    endTimeonConfirm(date) {
      console.log(date)
      this.endTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      this.state.showCalendar = false
    },
    goDelete(a) {
      this.$http({
        url: 'index/teacher/servicePackDelete',
        method: 'post',
        data: {
          id: a
        }
      }).then(res => {
        const _this = this
        if (res.status === 'success') {
          this.$toast('删除成功')
          setTimeout(function () {
            _this.$router.push({ name: 'TeacherServerPack' })
          }, 2000)
        } else {
          this.$toast.fail(res.message)
        }
      })
      // this.$router.push({ name: 'TeacherServerPack', paramas: { id: id } })
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      if (val < this.min_service_price_range || val > this.max_service_price_range) {
        return false
      }
      return true
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
  }

  .btn-area {
    .save-btn {
      width: 315px;
      height: 40px;
      background-color: #ff5c00;
      border-radius: 10px;
    }

    .del-btn {
      width: 315px;
      height: 40px;
      background-color: #f9f9f9;
      border-radius: 10px;
      color: $theme-color;
      margin-top: 15px;
    }
  }

  /deep/ .van-slider__bar {
    background-color: $theme-color;
  }

  /deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: $theme-color;
    border-color: $theme-color;
  }

  /deep/ .van-switch--on {
    background-color: $theme-color;
  }

</style>
